// extracted by mini-css-extract-plugin
export var Collapse = "styles-module--Collapse--83bcf";
export var arrow = "styles-module--arrow--0e52f";
export var clickDropdown = "styles-module--click-dropdown--70ca0";
export var collapseContent = "styles-module--collapseContent--ad9ec";
export var docArrow = "styles-module--doc-arrow--0a0fd";
export var expanded = "styles-module--expanded--f665e";
export var mainItem = "styles-module--mainItem--226c2";